import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Addon } from '@galaxy/marketplace-apps/v1';
import { AppPrice, AppPrices } from '@galaxy/marketplace-apps';

const DEFAULT_PAGE_SIZE = 4;

@Component({
  selector: 'store-addon-list',
  templateUrl: './addon-list.component.html',
  styleUrls: ['./addon-list.component.scss'],
  standalone: false,
})
export class AddonListComponent {
  @Input() addons: Addon[] = [];
  @Input() addonPrices: AppPrices[];
  @Input() currency: string;
  @Output() addonSelected = new EventEmitter<string>();
  pageSize = DEFAULT_PAGE_SIZE;

  onRowClicked(addon: Addon): void {
    this.addonSelected.emit(addon.addonId);
  }

  getAppPriceForIndex(index: number): AppPrice {
    if (this.addonPrices) {
      const pricingcontext = Object.keys(this.addonPrices[0].pricesForContexts)[0];
      if (pricingcontext) return this.addonPrices[index]?.pricesForContexts[pricingcontext];
    } else {
      return null;
    }
  }

  onLoadMoreClicked(): void {
    this.pageSize += DEFAULT_PAGE_SIZE;
  }
}
